<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="part"
    item-value="partCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'XrfInspResultCopyToInput',

  mixins: [APIUtils, Message],

  components: {
    SelectMultipleInput,
  },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0526')
      },
    },
    ignorePartCd: {
      type: String,
      required: true,
    },
    manufacturerCd: {
      type: String,
      required: true,
    },
    xrfGroupCd: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    manufacturerCd(value) {
      this.getItems(this.ignorePartCd, value, this.xrfGroupCd)
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    disabledComputed() {
      return this.disabled || this.items.length <= 0
    },
  },

  methods: {
    async getItems(ignorePartCd, manufacturerCd, xrfGroupCd) {
      try {
        this.loading = true
        if (!xrfGroupCd) {
          this.items = []
          return
        }
        const params = {
          manufacturerCd: manufacturerCd,
          xrfGroupCd: xrfGroupCd,
          validOnly: true,
        }
        const elements = await API.get('/xrfs', params)

        // 実績コピー先items
        this.items = elements
          .filter((e) => e.partCd != ignorePartCd)
          .map((e) => {
            e['part'] = `${e.partCd} : ${e.partName}`
            return e
          })

        // 初期値設定 全件選択
        this.model = this.items.map((e) => e.partCd)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0059') })))
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getItems(this.ignorePartCd, this.manufacturerCd, this.xrfGroupCd)
  },
}
</script>
